import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function CardNoticias({ imagem, nomeImagem, titulo, textoNoticia, linkNoticia }) {
  const [hovered, setHovered] = useState(false);

  const isSmallScreen = useMediaQuery('(max-width:600px)');

  const cardWidth = isSmallScreen ? 300 : 350;
  const cardHeight = isSmallScreen ? 200 : 200;


  const truncateText = (text, maxLength) => {
    if (typeof text === 'string') {
      const truncated = text.replace(/<[^>]*>/g, '').substring(0, maxLength);
      return truncated.length < text.length ? truncated + '...' : truncated;
    }
    return '';
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '40vh',
        marginBottom: '100px'
      }}
    >
      <Card
        sx={{
          width: cardWidth,
          height: cardHeight,
          borderRadius: '5px',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
        onMouseOver={() => setHovered(true)}
        onMouseOut={() => setHovered(false)}
      >
        {imagem ? (
          <CardMedia
            component="img"
            alt={nomeImagem}
            sx={{
              objectFit: 'cover',
              width: '100%',
              height: '100%',
            }}
            src={imagem}
          />
        ) : (
          <CardContent
            sx={{
              backgroundColor: 'blue',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <Typography variant="h5" component="div" sx={{ color: '#fff' }}>
              {titulo}
            </Typography>
          </CardContent>
        )}

        {hovered ? (
          <CardContent
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: '#ffffff',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="h5" component="div">
              {titulo}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {truncateText(textoNoticia, 140)}
            </Typography>
            <CardActions>
              <Button href={linkNoticia} size="small" target="_blank" rel="noopener noreferrer">
                Ir para a notícia
              </Button>
              <Button
                size="small"
                onClick={() => window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(linkNoticia)}`)}
              >
                Compartilhar
              </Button>
            </CardActions>
          </CardContent>
        ) : (
          <CardContent
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              padding: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Passe o mouse para ver a notícia
            </Typography>
          </CardContent>
        )}
      </Card>
    </Container>
  );
}
